module.exports = __webpack_public_path__ + "static/img/chenjmoney.e279c2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chenjmoney.png
// module id = U18P
// module chunks = 1